export const API_URL = "https://api.woodandwashi.com";
export const AUTH_URL = "https://services.woodandwashi.com/nav";
